import React from 'react';
import { Switch, Route } from 'react-router-dom';

//Constants
import Header from './constants/Header';
import Footer from './constants/Footer';

//Pages
import Landing from './pages/Landing';
import ElectricGuitars from './pages/electric-guitars/Electric-Guitars';
import GuitarItem from './pages/electric-guitars/guitar-item';

function App() {
  console.log(ElectricGuitars);
  return (
    <div className="app">
      <Header />
      <div className="app-body">
        <Switch>
          <Route path="/" exact component={Landing} />
          <Route path="/electric-guitars" exact component={ElectricGuitars} />
          <Route
            path={`/electric-guitars/:item`}
            exact
            component={GuitarItem}
          />
        </Switch>
      </div>
      <Footer />
    </div>
  );
}

export default App;
